
import { Booking } from "../../classes"
import { Invoice } from "../../classes"
const BookingModule = {
  namespaced: true,
  state: {
    bookingAreaCustomer: null,
    bookings: null,
    booking: null
  },
  mutations: {
    setBookingAreaCostomer(state, bookings) {
      state.bookingAreaCustomer = bookings || []
    },
    setBookings(state, bookings) {
      state.bookings = bookings || []
    },
    setBooking(state, booking) {
      state.booking = booking || []
    },
    clearBookings(state) {
      state.bookings = null
    },
    clearBooking(state) {
      state.booking = null
    },
  },
  actions: {
    createBooking: async ({ commit }, formData) => {
      try {
        commit("clearBooking")
        const data = await Booking.createBooking(formData)
        commit("setBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    editBooking: async ({ commit }, formData) => {
      try {
        commit("clearBooking")
        const data = await Booking.editBooking(formData)
        commit("setBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    cancelBooking: async ({ commit }, bookingId) => {
      try {
        commit("clearBooking")
        const data = await Booking.cancelBooking(bookingId)
        commit("setBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    checkInMonthlyBooking: async ({ commit }, bookingId) => {
      try {
        commit("clearBooking")
        const data = await Booking.checkInMonthlyBooking(bookingId)
        commit("setBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    checkInMonthlyBookingFirst: async ({ commit }, bookingId) => {
      try {
        const data = await Booking.checkInMonthlyBookingFirst(bookingId)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingByArea: async ({ commit }, areaId) => {
      try {
        commit("clearBookings")
        let data = await Booking.getBookingByArea(areaId)
        commit("setBookings", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingByAreaCustomer: async ({ commit }, payload) => {
      try {
        // commit("clearBookings")
        let data = await Booking.getBookingByAreaCustomer(payload)
        commit("setBookingAreaCostomer", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBooking: async ({ commit }, bookingId) => {
      try {
        commit("clearBooking")
        let data = await Booking.getBooking(bookingId)
        if (data.invoices && data.invoices.length) {
          data.invoices = data.invoices.map(invoice => new Invoice(invoice))
        }
        commit("setBooking", data)
        commit("areaBooking/setAreaBookings", data.areaBookings, { root: true });
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingBetweenDateByMarket: async ({ commit }, formData) => {
      try {
        commit("clearBookings")
        const data = await Booking.getBookingBetweenDateByMarket(formData)
        commit("setBookings", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingBetweenDateByProject: async ({ commit }, formData) => {
      try {
        commit("clearBookings")
        const data = await Booking.getBookingBetweenDateByProject(formData)
        commit("setBookings", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingCheckinToday: async ({ }, formData) => {
      try {
        const data = await Booking.getBookingCheckinToday(formData)
        return data
      } catch (error) {
        throw error
      }
    },
    getBookingByCustomerLimit: async ({ commit }, payload) => {
      try {
        // commit("clearBookings")
        let data = await Booking.getBookingByCustomerLimit(payload)
        // commit("setBookingAreaCostomer", data)
        return data
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getBookingAreaCustomer: (state) => state.bookingAreaCustomer,
    getBookingAreaCustomerInvoices: (state) => {
      let invoices = []
      if (state.bookingAreaCustomer && state.bookingAreaCustomer.length)
        for (const bookingAreaCustomer of state.bookingAreaCustomer) {
          if (bookingAreaCustomer.invoices && bookingAreaCustomer.invoices.length)
            for (const invoice of bookingAreaCustomer.invoices) {
              if (invoice.documentType == 8 && invoice.isSent && invoice.isPaid && invoice.documentId)
                invoices.push(invoice)
            }
        }
      return invoices
    },
    getBookings: (state) => state.bookings,
    getBooking: (state) => state.booking,
    getAreas: (state) => {
      let areas = []
      if (state.booking && state.booking.areaBookings)
        areas = state.booking.areaBookings.map(item => item.area)
      return areas
    },
    countAreaBooking: (state) => {
      let areaBookings = 0
      if (state.bookings && state.bookings.length)
        for (const booking of state.bookings) {
          areaBookings += (booking.areaBookings.length || 0)
        }
      return areaBookings
    },
    countBookingsSuccess: (state) => {
      let successBookings = []
      if (state.bookings && state.bookings.length)
        successBookings = state.bookings.filter(booking => booking.status == 'success')
      return successBookings.length
    }
  },
};
export default BookingModule;
